export const API_URL : string = 'https://gitore.dlmso.com:2030/api/v1'
export const AUTH_URL: string = 'https://gitore.dlmso.com:2030/api/v1'
export const DATA_URL: string = 'https://gitore.dlmso.com:2030/api/v1/data'
export const API_SOCKET: string = 'https://gitore.dlmso.com:2030'
export const CURRENCY: string = 'UGX'

